module.exports = __webpack_public_path__ + "img/add-list.bfe2e550.svg";